import { z } from "zod";
import { baseEntitySchema } from "./base";

export const stockCheckDataSchema = z.object({
  inventoryId: z.string(),
  checkedAt: z.date(),
  checkedBy: z.string(),
  reportedBalance: z.number(),
  systemBalanceAtCheck: z.number(),
  variance: z.number(),
  notes: z.string().optional(),
  attachmentUrl: z.string().optional(),
});

export type StockCheckData = z.infer<typeof stockCheckDataSchema>;
export const stockCheckSchema = baseEntitySchema.merge(stockCheckDataSchema);
export type StockCheck = z.infer<typeof stockCheckSchema>;
